<template>
    <div class="input-radio-group-container">
        <span v-if="title" class="group-title">{{ title }}</span>
        <div class="options-wrapper">
            <div v-for="(option, index) in options" :key="index" :class="[{ 'horizontal_margine': index !== 0 }]">
                <div class="d-flex flex-row">
                    <label :class="['scv-check-label-box']">
                        <input class="scv-check-label" type="radio" :name="name" :value="option.value" v-model="model"
                            :disabled="disabled" @change="onChange(option.change)" />
                        <span>{{ option.label }}</span>
                    </label>

                    <InformationManual v-if="option.information" :arMessage="[option.information]" :dispMode="1"
                        style="margin-left:4px;" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts" generic="T">
import { computed } from 'vue';
import { MessageUtil } from '@/models/Message/MessageUtil';
import InformationManual from '@/components/InformationManual.vue';

// --- Props & Emits ---
interface RadioOption {
    label: string;
    value: T;
    information?: string;
    change?: string;
}

interface Props {
    modelValue: T;
    name: string;
    title?: string; // 1. titleプロパティを追加
    disabled?: boolean;
    options: RadioOption[];
}

const props = withDefaults(defineProps<Props>(), {
    title: undefined, // デフォルトはundefined
    disabled: false
});

interface Emits {
    (e: 'update:modelValue', value: T): void;
    (e: 'changeState'): void;
}

const emit = defineEmits<Emits>();


// --- v-modelのためのcomputedプロパティ ---
const model = computed({
    get: () => props.modelValue,
    set: (newValue) => emit('update:modelValue', newValue)
});


// --- イベントハンドラ ---
const onChange = (message: string | undefined): void => {
    if (message) {
        MessageUtil.MessageBoxV2(message, null, null, MessageUtil.MB_ICON_WARNING);
    }
    emit('changeState');
};

</script>

<style scoped>
@import "../../../assets/css/setting.css";

.input-radio-group-container {
    height :32px;
    display: flex;
    align-items: center;
}

.group-title {
    margin-right: 8px;
    white-space: nowrap;
}

.options-wrapper {
    display: flex;
    align-items: center;
}
.horizontal_margine {
    margin-left: 24px;
}
</style>
